// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"SaveBookmark_bookmark__2xsS0","checked":"SaveBookmark_checked__28bex"};